import { ChangeDetectorRef, Component, DoCheck, KeyValueDiffer, KeyValueDiffers, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedConstants } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import * as _ from 'lodash';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { SclUtilDocumentService } from '../../../../formbird-sc-shared/src/lib/scl-util-document.service';
import { SclUtilUrlService } from '../../../../formbird-sc-shared/src/lib/scl-util-url.service';
import { FormbirdInjectorService } from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import { SearchService } from '../../../../formbird-services/src/lib/services/search/search.service';
import { TimeRecorderComponentDefinition } from './time-recorder.component.definition';

const logger = console;
const eventMapScope = 'event:mapScope';
@Component({
  templateUrl: './time-recorder.component.html',
  styleUrls: ['./time-recorder.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TimerRecorderComponent extends AbstractComponent<TimeRecorderComponentDefinition> implements OnInit, DoCheck {
  private documentDiffer: KeyValueDiffer<string, any>;

  isRequired: boolean;

  dataService: any;
  loggedInUserService: any;
  notificationService: any;
  modifiedFieldService: any;
  websocketService: any;
  docBean; timesheetDocs; currDocId; startEndTime; groupValues;
  target; socketEventName; socketEventGrpFldName; userAccountId; rootScope: any;
  objTimeSheet: {ckbTimeSheet: {}, noMatchViewing: {}};
  disableTimeSheet = true; // disabled by default, enable when document is not null

  constructor(
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilUrlService: SclUtilUrlService,
    private sclUtilDocumentService: SclUtilDocumentService,
    private differs: KeyValueDiffers,
    private searchService: SearchService,
    protected cdr: ChangeDetectorRef
  ) {

    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
    this.searchService = this.formbirdInjectorService.get('SearchService');
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.modifiedFieldService = this.formbirdInjectorService.get('ModifiedFieldService');
    this.websocketService = this.formbirdInjectorService.get('WebSocketService');
    this.objTimeSheet = {ckbTimeSheet: {}, noMatchViewing: {}};
  }

  ngOnInit() {
    this.documentDiffer = this.differs.find(this.document.systemHeader).create();

    this.componentSetupService.setupStandardProperties(this);

    if (!(typeof this.componentDefinition.mandatory === 'undefined' || this.componentDefinition.mandatory === null)) {
      this.isRequired = this.componentDefinition.mandatory;
    } else {
      this.isRequired = false;
    }

    this.disableTimeSheet = this.document.systemHeader.versionId ? false : true; // enable when document is created

    if ( typeof this.componentDefinition.linkDocument === 'undefined' || this.componentDefinition.linkDocument === null ) {
      this.componentDefinition.linkDocument = 'never';
    } else {
      this.componentDefinition.linkDocument = this.componentDefinition.linkDocument.toLowerCase();
    }
    if (!this.isAllowedLinkDocument(this.componentDefinition.linkDocument)) {
      this.componentDefinition.linkDocument = 'never';
    }
    this.userAccountId = this.loggedInUserService.user.account.documentId;

    this.docBean = this.template;
    this.timesheetDocs = null;
    this.componentDefinition.disableSave = true;
    this.rootScope = {mapScope: {}};

    this.getGroupFieldValue(this.document);

    this.ckbStatusHandle(this.document.documentId);

    this.websocketAddListner();

  }

  ngDoCheck() {
    const changes = this.documentDiffer.diff(this.document.systemHeader);
    if (changes) {
      this.documentChanged(changes);
    }
  }
  documentChanged(change) {
   if (change._additionsHead || change._changesHead || change._removalsHead) {
       let doc; doc = this.document;
       if (doc.parentId && doc.parentId.length > 0) {
         this.disableTimeSheet = false;
       }
       if (!_.isEqual(this.groupValues, this.document[this.componentDefinition.groupFilterField])) {
         this.websocketService.emit(this.socketEventGrpFldName, this.document.documentId);
       }
     }
  }

  isAllowedLinkDocument(linkDocument) {
    return ['icon', 'start',
      'stop', 'both', 'never']
      .find(value => linkDocument.toLowerCase() === value);
  }

  getGroupFieldValue(mainDoc) {
    let grpFiledValues;
    const grpFilterValues = mainDoc[this.componentDefinition.groupFilterField];

    if (this.componentDefinition.groupAccountField || this.componentDefinition.groupAccountControlField) {
      grpFiledValues = this.componentDefinition.groupAccountControlField ?
        this.loggedInUserService.user.accountControlDocument[this.componentDefinition.groupAccountControlField] :
        this.loggedInUserService.user.account[this.componentDefinition.groupAccountField];
    }

    if (this.componentDefinition.groupFilterField && !this.sclUtilDocumentService.isNew(this.document)) {
      // grpFiledValues = _.intersectionBy(grpFiledValues, grpFilterFieldValues, 'documentId');
      const result = [];
      if (grpFilterValues && grpFilterValues.length > 0) {
        for (let i = 0; i < grpFilterValues.length; i++) {
          let foundIndex = -1;
          for (let j = 0; j < grpFiledValues.length; j++) {
            if (grpFilterValues[i].documentId === grpFiledValues[j].documentId) {
              foundIndex = j;
              break;
            }
          }
          if (foundIndex > -1) {
            result.push(grpFiledValues[foundIndex]);
          } else if (this.componentDefinition.noMatchViewing === true) {
            let obj; obj = grpFilterValues[i];
            obj.noMatchViewing = true;
            result.push(obj);
          }
        }
      }
      grpFiledValues = result;
    }
    this.groupValues = grpFiledValues;
    return grpFiledValues;
  }

  displayTimer(mainDoc, groupValues?) {
     const self = this;
     if (groupValues && groupValues.length > 0) {
        groupValues.forEach(function(value, key) {
          self.objTimeSheet.ckbTimeSheet[value.documentId] = false;
          self.objTimeSheet.noMatchViewing[value.documentId] = false;
        });
     } else {
        self.objTimeSheet.ckbTimeSheet[self.loggedInUserService.user.account.documentId] = false;
        self.objTimeSheet.noMatchViewing[self.loggedInUserService.user.account.documentId] = false;
     }
  }

  getGroupField() {
    return this.componentDefinition.groupAccountControlField ?
      this.componentDefinition.groupAccountControlField : this.componentDefinition.groupAccountField;
  }

  callDisplayTimer(tsDocs?) {
    const grpField = this.getGroupField();
    if (grpField && this.groupValues && this.groupValues.length > 0) {
      const result = [];
      if (tsDocs && tsDocs.length > 0) {
        _.forEach(this.groupValues, function(groupVal, key) {
          const res = _.filter(tsDocs, function(tsDoc) {
            return tsDoc._source[grpField][0].documentId === groupVal.documentId;
          });
          if (res  && res.length > 0 || ((!res || res.length < 1) && !groupVal.noMatchViewing)) {
            result.push(groupVal);
          }
        });
      } else {
        _.forEach(this.groupValues, function(groupVal, key) {
          if (!groupVal.noMatchViewing) {
            result.push(groupVal);
          }
        });
      }

      this.displayTimer(this.document, result);
    } else {
      this.displayTimer(this.document);
    }
  }

  getDocument(docId) {
    return this.dataService.getDocument(docId);
  }

  updateCbxStatus(doc, currentTimesheetDoc) {
    const self = this;
    logger.info('TimeSheet: Update check box status for doc: ' + doc.documentId);
    self.getOpenTimesheetDocs().then(
      function successFunc(result) {
        if (!result) {
          const grpField =  self.getGroupField();
          let userId = self.loggedInUserService.user.account.documentId;
          if (grpField && currentTimesheetDoc) {
            if (currentTimesheetDoc[grpField]) {
              userId = currentTimesheetDoc[grpField][0].documentId;
            }
          }
          self.setTimeSheetStatus(false, userId);
        }

      },
      function errorFunc(err) {
        logger.error(err);
        self.setTimeSheetStatus(false);
      });
  }

  ckbStatusHandle(documentID, currentTimesheetDoc?) {
    const self = this;
    if (documentID && !self.sclUtilDocumentService.isNew(self.document)) {
      self.disableTimeSheet = self.componentDefinition.hasOwnProperty('enabled') ? !self.componentDefinition.enabled : false;
      self.getDocument(documentID)
        .then(function successFunc(currRecordedDoc) {
            self.updateCbxStatus(currRecordedDoc, currentTimesheetDoc);
          },
          function errorFunc(err) {
            logger.error(err);
          });
    } else {
      self.callDisplayTimer();
      self.disableTimeSheet = true;
    }
  }

  websocketAddListner() {
    const self = this;

    self.socketEventName = 'event:scTimeRecorderClose';
    self.websocketService.addEventListener(self.socketEventName, function(data) {
      if (data.maindDocId === self.document.documentId) {
        self.detectChanges();
        self.ckbStatusHandle(data.maindDocId, data.currentTimesheetDoc);
      }

    });

    self.socketEventGrpFldName = 'event:scTimeRecorderGropuFieldChange';
    if (self.componentDefinition.groupFilterField) {
      self.websocketService.addEventListener(self.socketEventGrpFldName, function(data) {
        if (data === self.document.documentId) {
          self.getDocument(self.document.documentId).then(function successFunc(currRecordedDoc) {
              self.getGroupFieldValue(self.document);
              self.detectChanges();
              self.ckbStatusHandle(self.document.documentId);
            },
            function errorFunc(err) {
              logger.error(err);
            });
        }

      });
    }
  }

  openRecordDoc(userId) {
    if (this.componentDefinition.linkDocument && (this.componentDefinition.linkDocument !== 'never')) {
      // openModal();
      const tsDoc = this.getCurrentTimesheetDoc(userId);
      this.sclUtilUrlService.openLink(tsDoc.documentId, 'overlay', this);
    }
  }

  handleClosePrior(userId) {
    const self = this;
    let promise;
    const promises = [];
    // if (scope.tplItem.autoClosePrior === true && !scope.tplItem.anyAccount) {
    if (self.componentDefinition.autoClosePrior === true) {
      // handle close all other timesheet document
      // build the filter to locate the timesheet records include the user and the parent templateId
      const mustQry = [];
      mustQry.push({ 'term': { 'systemHeader.templateId': self.componentDefinition.timesheetTemplateId }});
      let term = {};
      term[self.componentDefinition.accountDocField + '.documentId'] = self.loggedInUserService.user.account.documentId;

      const grpField = self.getGroupField();
      if (grpField && self.groupValues && this.groupValues.length > 0) {
        term = {};
        term[grpField + '.documentId'] = userId;
        mustQry.push({ 'term': term});
      } else {
        mustQry.push({ 'term': term});
      }

      mustQry.push({ 'exists': { 'field' : self.componentDefinition.startDateField}});
      const qFilter = '{ \'query\': { \'bool\': { \'must\':' +  JSON.stringify(mustQry) +
        ', \'must_not\': [ { \'exists\' : { \'field\' : \'' +
        this.componentDefinition.endDateField + '\' } } , {\'term\': {\'' + self.componentDefinition.parentDocField + '.documentId\' : \'' +
        this.document.documentId + '\' }}] } } }';

      logger.info('TimeSheet: autoClosePrior elastic query ' + qFilter);
      const options = {
        page: SharedConstants.DEFAULT_PAGE,
        pageSize: SharedConstants.DEFAULT_PAGE_SIZE,
        filter: qFilter
      };

      logger.info('TimeSheet: autoClosePrior Searching for related time recorders');
      self.searchService.search(options)
        .then(function(data) {
          const customData = _.cloneDeep(data.data.hits.hits);
          const isTheSameDoc = false;
          for (let i = 0; i < customData.length; i++) {
            logger.info('TimeSheet: autoClosePrior looping through time recorders to close[' +
              i + '] id : ' + customData[i]._source.documentId);
            const oriData =  _.cloneDeep(customData[i]._source);

            if (self.componentDefinition.parentDocField && (self.document.documentId !==
              oriData[self.componentDefinition.parentDocField][0].documentId || (customData.length > 1 &&
                self.currDocId !== oriData.documentId))) {
              if (!self.startEndTime) {
                self.startEndTime = new Date().toISOString();
              }
              customData[i]._source[self.componentDefinition.endDateField] = self.startEndTime;
              delete customData[i]._source[oriData[self.componentDefinition.parentDocField][0].documentId];
              promise = self.dataService.deepDiffUpdate(oriData, customData[i]._source);
              promises.push(promise);
            }
          }
          if (promises.length > 0) {
            Promise.all(promises).then(
              function successFunc(dataUpdated) {
                for (let j = 0; j < dataUpdated.length; j++) {
                  logger.info('TimeSheet: Updated related time recorder id ' + dataUpdated[j].documentId);
                  self.writeDataInstance('close', dataUpdated[j]);
                }
              },
              function errorFunc(err) {
                console.log(err);
              }
            );
          }
        });
    }
    self.startEndTime = undefined;
  }

  writeDataInstance(mode, docRecorded?, userId?) {
    let docId = this.document.documentId;
    if (docRecorded && docRecorded[this.componentDefinition.parentDocField]) {
      docId = docRecorded[this.componentDefinition.parentDocField][0].documentId;
    }

    if (mode === 'create') {
      const timesheetDoc = this.getCurrentTimesheetDoc(userId);
      this.currDocId = timesheetDoc.documentId;
      this.rootScope.mapScope[this.currDocId] = this;
      if (this.componentDefinition.linkDocument && (this.componentDefinition.linkDocument === 'start' ||
        this.componentDefinition.linkDocument === 'both')) {
        // openModal();
        const tsDoc = this.getCurrentTimesheetDoc(userId);
        this.sclUtilUrlService.openLink(tsDoc.documentId, 'overlay', this);
      }
      this.handleClosePrior(userId);
    } else if (mode === 'close') {
      if (docRecorded && docRecorded.documentId) {
        const tmpScope = this.rootScope.mapScope[docRecorded.documentId];
        if (tmpScope) {
          tmpScope.ckbTimeSheet = false;
        }
      }
      if (docId !== this.document.documentId && this.componentDefinition.autoClosePrior === true) {
        // WebSocketService.emit(socketEventName, {"maindDocId" : _docId, "currentTimesheetDoc" : docRecorded} );
      } else {
        if (this.componentDefinition.linkDocument && (this.componentDefinition.linkDocument === 'stop' ||
          this.componentDefinition.linkDocument === 'both')) {
          // openModal();
          const tsDoc1 = this.getCurrentTimesheetDoc(userId);
          this.sclUtilUrlService.openLink(tsDoc1.documentId, 'overlay', this);
        }
      }
    }
    this.websocketService.emit(this.socketEventName, {'maindDocId' : docId, 'currentTimesheetDoc' : docRecorded} );
  }

  loadDefaultFields(savedData) {
    const relatedFields = this.componentDefinition.relatedFields;
    if (relatedFields && this.document) {
      const data = this.document;
      const defObj = {};
      relatedFields.foreach(function(value, key) {
        if (value === 'documentId') {
          defObj[key] = data.documentId;
        } else {
          defObj[key] = data[value];
        }
      });
      savedData.relatedFields = defObj;
    }
    return savedData;
  }

  insertTimeSheet(userId) {
    const self = this;
    let savedData;  savedData = {};
    savedData.systemHeader = {};

    const grpField =  self.getGroupField();
    if (grpField && self.groupValues && self.groupValues.length > 0) {
      for (let i = 0; i < self.groupValues.length; i++) {
        if (self.groupValues[i].documentId === userId) {
          savedData[grpField] = [self.groupValues[i]];
          break;
        }
      }
    }

    if (self.componentDefinition.accountDocField) {
      if (!savedData[self.componentDefinition.accountDocField]) {
        savedData[self.componentDefinition.accountDocField] = [];
      }

      let account; account = {};
      account.name = this.loggedInUserService.user.account.systemHeader.summaryName;
      account.documentId = this.loggedInUserService.user.account.documentId;
      savedData[self.componentDefinition.accountDocField].push(account);

    }

    if (self.componentDefinition.parentDocField) {
      if (!savedData[self.componentDefinition.parentDocField]) {
        savedData[self.componentDefinition.parentDocField] = [];
      }
      let task; task = {};
      task.name = this.document.systemHeader.summaryName;
      task.documentId = this.document.documentId;
      task.fieldName = self.componentDefinition.name;
      savedData[self.componentDefinition.parentDocField].push(task);
    }
    if (self.componentDefinition.startDateField) {
      if (!self.startEndTime) {
        self.startEndTime = new Date().toISOString();
      }
      savedData[self.componentDefinition.startDateField] = self.startEndTime;
    }

    if (self.componentDefinition.anyAccount) {
      savedData.createdBy = {
        name: self.loggedInUserService.user.account.systemHeader.summaryName,
        documentId: self.loggedInUserService.user.account.documentId
      };
    }


    savedData.systemHeader.systemType = SharedConstants.SYSTEM_TYPE_DOCUMENT;
    savedData.systemHeader.templateId = self.componentDefinition.timesheetTemplateId;
    if (!savedData.systemHeader.summaryName) {
      savedData.systemHeader.summaryName = 'Timesheet - ' +
        this.loggedInUserService.user.account.systemHeader.summaryName;
    }
    savedData.systemHeader.excludeGeneralSearch = false;
    if (self.componentDefinition.excludeGeneralSearch) {
      savedData.systemHeader.excludeGeneralSearch = self.componentDefinition.excludeGeneralSearch;
    }

    logger.info('TimeSheet: Inserting new time recorder');
    if (self.componentDefinition.relatedFields) {
      savedData = self.loadDefaultFields(savedData);
    }
    //savedData[self.document.documentId] = self.componentDefinition.name;
    self.dataService.insert(savedData)
      .then(function successFunc(data) {
          logger.info('TimeSheet: Create new record timesheet success, has id ' + data.documentId);
          self.setCurrentTimesheetDoc(userId, data);
          self.writeDataInstance('create', null, userId);
          // enable checkbox
          self.disableTimeSheet = false;
          localStorage.setItem('isSaving', '');
        },
        function errorFunc(err) {
          logger.error('Error when inserting new time recorder to db, ' + err);
        });
  }

  recordTimeSheet(userId) {
    const self = this;
    const ckbTimeSheet = self.getTimeSheetStatus(userId);
    const isSaving = localStorage.getItem('isSaving');
    if (isSaving && isSaving !== '') {
      self.notificationService.printMessage('The record timesheet ' + isSaving + ' is processing. Please wait a second.', 'info');
      self.setTimeSheetStatus(false, userId);
      return;
    }
    self.document[self.componentDefinition.name] = ckbTimeSheet;
    if (self.modifiedFieldService.isDirty()) {
      localStorage.setItem(self.document.documentId, 'false');
    } else {
      localStorage.setItem(self.document.documentId, 'true');
    }
    if (ckbTimeSheet === true) {
      // handle create new timesheet document
      if (self.docBean !== null) {
        if (self.componentDefinition.timesheetTemplateId) {
          logger.info('TimeSheet: Starting new time recorder');
          // Disable checkbox util save new timesheet document finish
          self.disableTimeSheet = true;
          localStorage.setItem('isSaving', self.componentDefinition.name);
          self.getDocument(self.componentDefinition.timesheetTemplateId).then(function successFunc(timeSheetTpl) {
              self.insertTimeSheet(userId);
            },
            function errorFunc(err) {
              const eMsg = 'Can not get timesheet Template record id : ' + self.componentDefinition.timesheetTemplateId + ', ' + err;
              logger.error(eMsg);
              self.setTimeSheetStatus(false, userId);
              self.disableTimeSheet = false;
              localStorage.setItem('isSaving', '');
              self.notificationService.printMessage(eMsg, 'error');
            });
        }
      }
    } else {
      const timesheetDoc = self.getCurrentTimesheetDoc(userId);
      logger.info('TimeSheet: Ending time recorder id ', timesheetDoc.documentId);
      // handle update endTime
      // tslint:disable-next-line:no-shadowed-variable
      self.getDocument(timesheetDoc.documentId).then(function successFunc(timesheetDoc) {
          if (self.componentDefinition.endDateField && !timesheetDoc[self.componentDefinition.endDateField]) {
            const newTimeSheet = _.cloneDeep(timesheetDoc);
            const currTime = new Date().toISOString();
            newTimeSheet[self.componentDefinition.endDateField] = currTime;
            if (self.componentDefinition.anyAccount) {
              newTimeSheet.closedBy = {
                name: self.loggedInUserService.user.account.systemHeader.summaryName,
                documentId: self.loggedInUserService.user.account.documentId
              };
            }
            //delete newTimeSheet[self.document.documentId];
            self.dataService.deepDiffUpdate(timesheetDoc, newTimeSheet)
              .then(function successFunction(data) {
                  logger.info('TimeSheet: Updated end time of time recorder, has id ' + data.documentId);
                  // remove pending data after finishing record doc
                  self.writeDataInstance('close', data);
                  self.removeCurrentTimesheetDoc(data.documentId);
                },
                function errorFunc(err) {
                  logger.error('Updated end time error, doc has id ' + timesheetDoc.documentId + ', ' + err);
                });

          } else {
            self.writeDataInstance('close');
          }
        },
        function errorFunc(err) {
          logger.error('Can not get record id : ' + timesheetDoc.documentId + '' + err);
        });
    }

  }

  getTimeSheetStatus(userId) {
    if (!userId) {
      userId = this.loggedInUserService.user.account.documentId;
    }
    return this.objTimeSheet.ckbTimeSheet[userId];

  }

  setTimeSheetStatus(flag, userId?) {
    const grpField =  this.getGroupField();
    let groupId;

    if (grpField && this.groupValues) {
      groupId = userId;
    } else {
      groupId = this.loggedInUserService.user.account.documentId;
    }
    this.objTimeSheet.ckbTimeSheet[groupId] = flag;
    this.detectChanges();
  }

  setNoMatchViewing(tsDoc, userId, isGroup) {

    let flag = false;
    if (tsDoc && isGroup) {
      if (this.componentDefinition.noMatchViewing === true) {
        const grpField = this.getGroupField();
        const grpValues = this.componentDefinition.groupAccountControlField ?
          this.loggedInUserService.user.accountControlDocument[this.componentDefinition.groupAccountControlField] :
          this.loggedInUserService.user.account[this.componentDefinition.groupAccountField];

        const res = _.filter(grpValues, function(item) {
          return item.documentId === tsDoc[grpField][0].documentId;
        });
        flag = (!res  || res.length < 1);
      }

    } else if (tsDoc) {
      const docAccountId = tsDoc[this.componentDefinition.accountDocField][0].documentId;
      flag = (docAccountId !== userId && !this.componentDefinition.anyAccount && this.componentDefinition.noMatchViewing === true);
    }

    this.objTimeSheet.noMatchViewing[userId] = flag;

  }

  getCurrentTimesheetDoc(userId) {
    const res = _.filter(this.timesheetDocs,  {'userId' : userId});
    if (res && res.length > 0) {
      return res[0].timesheetDoc;
    } else {return {}; }
  }

  setCurrentTimesheetDoc(userId, doc) {
    if (!this.timesheetDocs) {
      this.timesheetDocs = [];
    }
    this.timesheetDocs.push({'userId' : userId, 'timesheetDoc' : doc});
  }

  removeCurrentTimesheetDoc(docId) {
    this.timesheetDocs = _.remove(this.timesheetDocs,  {'timesheetDoc.documentId' : docId});
  }

  getOpenTimesheetDocs() {
    const self = this;
    const deferred = new Promise((resolve, reject) => {

      const mustQry = [];
      mustQry.push({'term': {'systemHeader.templateId': this.componentDefinition.timesheetTemplateId}});
      let term;  term = {};
      term[this.componentDefinition.accountDocField + '.documentId'] = this.loggedInUserService.user.account.documentId;

      const grpField = this.getGroupField();
      if (grpField && this.groupValues && this.groupValues.length > 0) {
        const shouldQry = [];
        for (let i = 0; i < this.groupValues.length; i++) {
          term = {};
          term[grpField + '.documentId'] = this.groupValues[i].documentId;
          shouldQry.push({'term': term});
        }
        mustQry.push({'bool': {'should': shouldQry, 'minimum_should_match': 1}});
      } else if (!this.componentDefinition.anyAccount && !this.componentDefinition.noMatchViewing) {
        mustQry.push({'term': term});
      }


      term = {};
      term[this.componentDefinition.parentDocField + '.documentId'] = this.document.documentId;
      mustQry.push({'term': term});
      term = {};
      term[this.componentDefinition.parentDocField + '.fieldName'] = this.fieldName;
      mustQry.push({'term': term});

      mustQry.push({'exists': {'field': this.componentDefinition.startDateField}});
      const qFilter = '{ \'query\': { \'bool\': { \'must\':' + JSON.stringify(mustQry) +
        ', \'must_not\': [ { \'exists\' : { \'field\' : \'' +
        this.componentDefinition.endDateField + '\' } } ] } } }';

      logger.info('TimeSheet: get open time sheet query ' + qFilter);
      const options = {
        page: SharedConstants.DEFAULT_PAGE,
        pageSize: SharedConstants.DEFAULT_PAGE_SIZE,
        filter: qFilter
      };


      let openTimesheetDocs;
      self.searchService.search(options)
        .then(function(data) {
          const timeSheets = data.data.hits.hits;
          if (timeSheets.length > 0) {
            openTimesheetDocs = [];
            self.timesheetDocs = [];
            let doc;
            self.objTimeSheet.ckbTimeSheet = {};
            if (grpField && self.groupValues && self.groupValues.length > 0) {
              self.callDisplayTimer(timeSheets);
              for (let i = 0; i < self.groupValues.length; i++) {
                const res = _.filter(timeSheets, function(item) {
                  return item._source[grpField][0].documentId === self.groupValues[i].documentId;
                });
                if (res && res.length > 0) {
                  doc = res[0]._source;
                  openTimesheetDocs.push(doc);
                  self.setTimeSheetStatus(true, self.groupValues[i].documentId);
                  self.setCurrentTimesheetDoc(self.groupValues[i].documentId, doc);
                  self.rootScope.mapScope[doc.documentId] = self;
                  self.setNoMatchViewing(doc, self.groupValues[i].documentId, true);
                } else {
                  self.setTimeSheetStatus(false, self.groupValues[i].documentId);
                }
              }

            } else {
              self.displayTimer(self.document);
              doc = timeSheets[0]._source;
              openTimesheetDocs.push(doc);
              self.setTimeSheetStatus(true, self.loggedInUserService.user.account.documentId);
              self.setCurrentTimesheetDoc(self.loggedInUserService.user.account.documentId, doc);
              self.rootScope.mapScope[doc.documentId] = self;
              self.setNoMatchViewing(doc, self.loggedInUserService.user.account.documentId, false);
            }

          } else {
            self.callDisplayTimer();
          }
          resolve(openTimesheetDocs);
        }, function(err) {
          resolve(openTimesheetDocs);
        });
    });

    return deferred;
  }


  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
